import API from "../api";
import { PayloadNotificationListType } from "../types";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async requestIsNotification(): Promise<boolean> {
      const { data } = await API.getIsNotification();
      return data;
    },
    async requestNotificationWasSeen(
      context: any,
      payload: number
    ): Promise<any> {
      const { data } = await API.getNotificationWasSeen(payload);
      return data;
    },
    async requestNotificationList(
      context: any,
      payload: PayloadNotificationListType
    ): Promise<any> {
      const { data } = await API.getNotificationList(payload);
      return data;
    },
    async requestNotificationConfigure(
      context: any,
      payload: any
    ): Promise<any> {
      const { data } = await API.putNotificationConfigure(payload);
      return data;
    },
    async requestNotificationConfig(): Promise<any> {
      const { data } = await API.getNotificationConfig();
      return data;
    },
    async requestIsMessageNotification(): Promise<boolean> {
      const { data } = await API.getIsMessageNotification();
      return data;
    },
    async requestNotificationRead(context: any, payload: number): Promise<any> {
      const { data } = await API.patchNotificationRead(payload);
      return data;
    },
    async requestNotificationUnread(
      context: any,
      payload: number
    ): Promise<any> {
      const { data } = await API.patchNotificationUnread(payload);
      return data;
    },
    async requestNotificationDelete(
      context: any,
      payload: number
    ): Promise<any> {
      const { data } = await API.deleteNotification(payload);
      return data;
    },
    async requestNotificationAllRead(): Promise<any> {
      const { data } = await API.patchNotificationAllRead();
      return data;
    },
  },
  modules: {},
};
